import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { withStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
import { CardContent, CardActions } from '@material-ui/core';

import SubscriptionForm from './SubscriptionForm';
import ConfirmButton from '../ConfirmButton';
import { isValid } from '../../helpers/subscription';
import { PERIODICITY } from '../../actions/products';

/**
 * Change subscription form
 * Displayed in the subscription page, when clicking on "Change subscription"
 */

const styles = theme => ({
  card: {
    marginBottom: theme.spacing.unit
  },
  buyLicencesForm: {
    //alignItems: "flex-end"
  },
  action: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  updateButton:{
    flex: 1,
    marginTop: 16,
    marginBottom: 16,
  },
  purchaseButton: {
    flex: 1,
    marginTop: 16,
    marginBottom: 16,
    borderRadius: 24,
    backgroundColor: '#3E82F7',
    boxShadow: 'none'
  },
  purchaseExpandedButton: {
    flex: 1,
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 56,
    marginRight: 56,
    borderRadius: 24,
    backgroundColor: '#3E82F7',
    boxShadow: 'none'
  },
  form: {
    flexGrow:1,
  },
  expand: {
    display:'flex', 
    flexDirection:'row', 
    justifyContent:'space-between', 
  },
  expandIconColor: {
    color: '#797979'
  },
});

class ChangeSubscription extends Component {

  constructor(props) {
    super(props);

    const { licencesCount, plan } = props.subscription;
    this.state = {
      licencesCount,
      plan,
      switchOnMonthlyPlans: plan.periodicity === PERIODICITY.MONTHLY ? true : false,
    };

    this.handleSwitchOnPeriod = this.handleSwitchOnPeriod.bind(this);
  }

  /**
   * Handle the chosen periodicity related to Others plans displayed  
   * @param {*} chosenPeriodicity 
   */
  handleSwitchOnPeriod (chosenPeriodicity) {
    const {product, subscription} = this.props;
    const targetPlan = product.plans.find(plan => plan.name === subscription.plan.name && plan.periodicity === chosenPeriodicity)
    if (chosenPeriodicity === PERIODICITY.MONTHLY) {
      this.setState({switchOnMonthlyPlans: true});
    } 
    if (chosenPeriodicity === PERIODICITY.YEARLY) {
      this.setState({switchOnMonthlyPlans: false});
    }
    this.setState({plan: targetPlan});
  }

  /** 
   * Calls the API to update the subscription,
   * then closes the form if all went well
  */
  update() {
    const {
      licencesCount,
      plan
    } = this.state;

    this.props.handleUpdatePlan(
      plan,
      licencesCount
    );
  }


  /**
   * Called when the licences count changed
   * No op if new licences count is fewer than the plan's number of licences
   * @param {Integer} licencesCount New licences count value
   */
  handleLicencesCount(licencesCount) {
    this.setState({ licencesCount });
  }

  /** 
   * Returns true if any of the form values changed
  */
  hasChanged() {
    const { subscription } = this.props;
    const { licencesCount, plan } = this.state;
    return licencesCount !== subscription.licencesCount || plan.periodicity !== subscription.plan.periodicity;
  }

  /**
   * Returns true if the state has valid infos
   */
  isValid() {
    const { licencesCount } = this.state;
    const { subscription } = this.props;
    return isValid(subscription.plan, licencesCount);
  }


  render() {
    const {
      product,
      classes,
      subscription,
      isBothPeriodicityAvailable,
      handleCurrentPlanUpdate,
    } = this.props;

    const {
      licencesCount,
      plan
    } = this.state;

    const hasChanged = this.hasChanged();
    const isValid = this.isValid();

    const isTrialing = subscription.status === 'trialing';
    const withRedirection = !subscription.hasPaymentInfo;
    const disabledPurchase = !!subscription.updatingOn 
        || (subscription.hasPaymentInfo && subscription.status ==='trialing')
        || (subscription.hasPaymentInfo && subscription.status ==='active' && !hasChanged)
      
    
    return (
      <div>
          <Divider />
          <CardContent >
            <div className={classes.expand} >
                <SubscriptionForm
                  plans={product.plans}
                  plan={subscription.plan}
                  subscription={subscription}
                  licencesCount={licencesCount}
                  handleLicencesCount={licencesCount => this.handleLicencesCount(licencesCount)}
                  handleSwitchOnPeriod={this.handleSwitchOnPeriod}
                  isBothPeriodicityAvailable={isBothPeriodicityAvailable}
                  switchOnMonthlySubscriptionPlan={this.state.switchOnMonthlyPlans}
                  targetPlan={this.state.plan} 
                />
            </div>
          </CardContent>
          <CardActions className={classes.actions}>
            {isTrialing &&
              <ConfirmButton
                className={classes.updateButton}
                title={<FormattedMessage id="subscription.confirmation.update.plan.title" />}
                message={<FormattedMessage id="subscription.confirmation.update.plan" />}
                variant="text"
                fullWidth
                size='medium'
                onClick={() => this.update()}
                disabled={!!subscription.updatingOn || !isValid || !hasChanged}
              >
                <FormattedMessage id='plan.update.button' />
              </ConfirmButton>
            }
            <ConfirmButton
              className={isTrialing ? classes.purchaseButton : classes.purchaseExpandedButton}
              variant="contained"
              size="medium" 
              color="primary"
              title={withRedirection 
                ? null 
                : <FormattedMessage id="subscription.confirmation.update.plan.title" />
              }
              message={withRedirection 
                ? <FormattedMessage id="subscription.confirmation.chargify.redirection" /> 
                : <FormattedMessage id="subscription.confirmation.update.plan" />
              }
              onClick={withRedirection ? () => handleCurrentPlanUpdate({plan, licencesCount}) : () => this.update()}
              disabled={disabledPurchase || !isValid}
            >  
              <FormattedMessage id='plan.button.purchase' /> 
            </ConfirmButton> 
            
          </CardActions>
      </div>
    )
  }
}

ChangeSubscription.propTypes = {
  product: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
}

export default withStyles(styles)(
  ChangeSubscription
);



// WEBPACK FOOTER //
// ./src/components/subscriptions/ChangeSubscription.js